import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, Loader } from 'core/components';

function OnHoldTemplate({ onHoldViewStore: { form, loading, onHoldReasonDropdownStore }, t }) {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">{t('ONHOLDVIEW.ONHOLD')}</h2>
				</div>
				<div className="ReactModal__body">
					<BaasicDropdown
						dropdownStore={onHoldReasonDropdownStore}
						isClearable={true}
						label={t('ONHOLDVIEW.ONHOLDREASON')}
					/>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(OnHoldTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OnHoldTemplate.jsx